@use '@/sass/variables';

.header {
  padding: variables.$spacing-medium;
  font-size: variables.$font-size-6;
  font-weight: 700;
  color: variables.$dark-gray;
}

.viewList {
  max-height: 300px;
  overflow-y: auto;
}

.viewItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: variables.$spacing-small variables.$spacing-medium;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: variables.$font-size-6;
  color: variables.$near-black;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: variables.$light-gray;
  }

  &.active {
    color: variables.$blue;
    font-weight: 500;
    background-color: variables.$lightest-blue;
  }
}

.viewName {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: variables.$spacing-small;
  text-align: left;
  font-size: variables.$font-size-5;
}

.viewActions {
  display: flex;
  align-items: center;
  gap: variables.$spacing-extra-small;
}

.checkIcon {
  color: variables.$blue;
  font-size: 12px;
}

.deleteButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: variables.$gray;
  transition: all 0.15s ease;

  &:hover:not(.disabled) {
    background-color: variables.$washed-red;
    color: variables.$red;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.divider {
  height: 1px;
  background-color: variables.$moon-gray;
  margin: variables.$spacing-extra-small 0;
}

.saveSection {
  border-top: 1px solid variables.$moon-gray;
  padding: variables.$spacing-medium;
}

.trigger {
  max-width: 14rem;

  > span {
    display: inline-block;
    max-width: calc(100%);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}
